import axios from "axios";
import React, { useContext, useMemo, useRef } from "react";
import { useState } from "react";
import { useEffect } from "react";
import { Header } from "./Header";

import { Footer } from "./Footer";
import Banner from "./components/Banner";
import toast from "react-hot-toast";
import LoginReg from "./LoginReg";
import { AuthContext } from "../context/Authcontext";
import "../assets/AdminCss/games.css";

const base_url = process.env.REACT_APP_API_URL;

const VirtualSports = () => {
  const [isSidebar, setSidebar] = useState(false);
  const { isAuthenticated } = useContext(AuthContext);
  const [active, setActive] = useState(false);
  const token= localStorage.getItem('game_token');
  const [gamess, setGamess]= useState([]);

  const handleGames = async () => {
    try {
      const response = await axios.get(
        base_url + "/api/webapi/particularGameType",
        {
          params: {
            token,
          },
          withCredentials: true,
          headers: {
            "content-type": "application/json",
          },
        }
      );
    //   console.log("games", response);
      const games = response?.data?.items;

      setGamess(games);
    } catch (err) {
      console.log(err);
    }
  };

  const openGameById = async (gameId) => {
    try {
      const response = await axios.post(
        base_url + "/api/gamelaunch/url",
        { token, gameId },
        {
          withCredentials: true,
          headers: {
            "content-type": "application/json",
          },
        }
      );

      if (response?.data.success) {
        const url = response?.data.url;
        window.location.href = url;
      } else {
        toast.error("Please Login to play!");
        setActive(true);
      }
    } catch (err) {
      console.log(err);
      toast.error("Unable to launch game. Please try again.");
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);

    handleGames();
  }, []);

  return (
    <>
    {<LoginReg active={active} setactive={setActive} />}
    <app-root _nghost-jrx-c101="" ng-version="12.2.16">
      <div _ngcontent-jrx-c101="">
        <app-toasts
          _ngcontent-jrx-c101=""
          aria-live="polite"
          aria-atomic="true"
          className="ngb-toasts"
        ></app-toasts>
        <router-outlet _ngcontent-jrx-c101=""></router-outlet>
        <app-landing-page-new _nghost-jrx-c95="" className="ng-star-inserted">
          <div _ngcontent-jrx-c95="" className="head-container gamess">
            <div _ngcontent-jrx-c95="" className="body-container">
              <div
                _ngcontent-jrx-c95=""
                className={`rightbar`}
                style={{
                  width: isSidebar ? "" : "100%",
                  transition: "width 0.3s ease-in-out",
                }}
              >
                <Header isSidebar={isSidebar} setSidebar={setSidebar} />
                <div className="news-bar"></div>
                <Banner />

                <app-upcoming
                  _ngcontent-jrx-c95=""
                  _nghost-jrx-c94=""
                  className="ng-star-inserted"
                >
                    <div className="w-100 text-center my-4 rounded bg-cyan fs-3">Virtual Sports</div>
                  <div className="d-flex flex-wrap">
                    {gamess?.map((game, index) => (
                        <div
                            key={game?.id || index}
                            className="col-6 mb-4 game-card-wrapper"
                            onClick={() => {
                            if (isAuthenticated) openGameById(game?.id);
                            }}
                        >
                            <div className="rounded shadow-sm w-100" style={{ cursor: "pointer" }}>
                            <div className="pop-carousel">
                                <img
                                className="slider-sport rounded-top img-fluid w-100"
                                src={game?.images?.[2]?.url}
                                alt={game?.category || "Casino Game"}
                                style={{ height: "14rem" }}
                                loading="lazy"
                                />
                            </div>
                            <div
                                className="w-100 d-flex flex-column gap-2 pb-3 px-2 rounded-bottom"
                                style={{ background: "#393939" }}
                            >
                                <span style={{ color: "#959292", fontSize: "12px" }}>
                                Virtual Sports
                                </span>

                                <h3 className="text-white m-0 fnsz">{game?.name}</h3>

                                <span style={{ color: "#959292", fontSize: "12px" }}>
                                {game?.provider?.name}
                                </span>
                            </div>
                            {!isAuthenticated && (
                                <div className="login-overlay d-flex justify-content-center align-items-center">
                                <button
                                    className="btn text-white fw-bold btnnn"
                                    onClick={(e) => {
                                    e.stopPropagation();
                                    setActive(true);
                                    }}
                                >
                                    LOGIN
                                </button>
                                </div>
                            )}
                            {isAuthenticated && (
                                <div className="play-overlay d-flex justify-content-center align-items-center">
                                <button
                                    className="btn text-white fw-bold btnnn"
                                    onClick={(e) => {
                                    e.stopPropagation();
                                    openGameById(game?.id);
                                    }}
                                >
                                    PLAY NOW
                                </button>
                                </div>
                            )}
                            </div>
                        </div>
                        ))}
                    </div>

                </app-upcoming>
                

                <Footer />
              </div>
            </div>
          </div>
        </app-landing-page-new>

        <div className="slider-container"></div>
      </div>
    </app-root>
    </>
  );
};

export default VirtualSports;
